export default async function auth ({ next, app }){    
    if(!app.config.globalProperties.$auth.user.data){    
        await app.config.globalProperties.$auth.check();
    } 
    if(!app.config.globalProperties.$auth.user.data){
        return next({name: 'main'});
    }else{
        return next()
    }
}